(function (window, $j) {
    $j(document).ready(function () {
        var myReservationForm = $j("#my-reservation-form");
        var msgLastName = myReservationForm.find("#hdnMyReserveLastName").val();
        var msgconfirmationNum = myReservationForm.find("#hdnMyReserveConfirmationNumber").val();

        //form validation and submit - uses jQuery validation plugin
        myReservationForm.validate({
            submitHandler: function (form) {
                var lastName = $j(form).find("#reservationLastNameTxt").val();
                var confirmationNumber = $j(form).find("#reservationNumberTxt").val();
                var sslUrl = $j(form).find("button[type=submit]").data("href");
                var url = sslUrl.replace("{0}", lastName).replace("{1}", confirmationNumber);
                window.location.href = url;
            },
            rules: {
                "reservationLastNameTxt": "required",
                "reservationNumberTxt": "required"
            },
            messages: {
                "reservationLastNameTxt": msgLastName,
                "reservationNumberTxt": msgconfirmationNum
            }
        });
    });
})(window, $j);